(() => {
  const TXT_IN   = '2-4 dages levering';
  const TXT_WARN = '5-7 dages levering ';
  const TXT_OUT  = 'Udsolgt';
  const TXT_PICK = 'Vælg størrelse';

  function badge() {
    return document.querySelector('[data-raaw-stock]');
  }

  function setBadge(state, text) {
    const el = badge();
    if (!el) return;

    el.classList.remove(
      'raaw-stockbutton--green',
      'raaw-stockbutton--yellow',
      'raaw-stockbutton--neutral',
      'raaw-stockbutton--soldout'
    );
    el.classList.add(`raaw-stockbutton--${state}`);
    el.textContent = text;
  }

  function getQtyMap() {
    const el = document.querySelector('script[data-raaw-variant-qty]');
    if (!el) return [];
    try {
      const v = JSON.parse(el.textContent || '[]');
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  }

  function getSelectedVariantId() {
    const a = window?.ShopifyAnalytics?.meta?.selectedVariantId;
    if (a) return a;

    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value) return idInput.value;

    const params = new URLSearchParams(window.location.search);
    const v = params.get('variant');
    if (v) return v;

    return null;
  }

  function update() {
    const el = badge();
    if (!el) return;

    const map = getQtyMap();
    if (!map.length) {
      setBadge('neutral', TXT_PICK);
      return;
    }

    const vid = getSelectedVariantId();
    if (!vid) {
      setBadge('neutral', TXT_PICK);
      return;
    }

    const row = map.find(x => Number(x.id) === Number(vid));
    if (!row) {
      setBadge('neutral', TXT_PICK);
      return;
    }

    const qty = Number(row.qty);

    // 🔴 Udsolgt (kan ikke købes)
    if (row.available === false) {
      setBadge('soldout', TXT_OUT);
      return;
    }

    // 🟢 På lager
    if (Number.isFinite(qty) && qty >= 1) {
      setBadge('green', TXT_IN);
      return;
    }

    // 🟡 Ikke på lager, men kan bestilles
    setBadge('yellow', TXT_WARN);
  }

  function init() {
    update();

    document.addEventListener('click', () => {
      setTimeout(update, 0);
      setTimeout(update, 60);
      setTimeout(update, 160);
    }, true);

    document.addEventListener('change', () => {
      setTimeout(update, 0);
      setTimeout(update, 60);
    }, true);

    let i = 0;
    const t = setInterval(() => {
      update();
      i += 1;
      if (i >= 20) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
